import React, { Component, Fragment } from "react";
import { Link } from 'react-router-dom';


import Content from "../../components/Content/ContentPage/Content";
import ContentHeader from "../../components/Content/ContentHeader/ContentHeader";
import Card from "../../components/Card/Card";
import MessageHandler from "../../components/MessageHandler/MessageHandler";
import Newloader from "../../components/Loader/NewLoader/NewLoader";
import ErrorHandler from "../../components/ErrorHandler/ErrorHandler";
import Paginator from '../../components/Paginator/Paginator';
import { dateTimeOnlyReadable } from "../../util/dateTime";

import Input from "../../components/Form/Input/Input";

import "./OrderList.css";



class OrderList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dirham_price: null,
      paymentGatewayIsActive: false,
      searchValue: "",
      searchTouched: false,
      products: [],
      active: false,
      searchFiled: "",
      code: 0,
      label: "",
      title: "",
      isEditing: false,
      editingData: {},
      totalProducts: 0,
      perPage: 10,
      productPage: 1,
      productsLoading: true,
    };
  }

  componentDidMount() {
    this.loadProducts(1);
    this.paymentGatewayStatus();
  }



  loadProducts = (productPage, searchData = "") => {
    if (productPage) {
      this.setState({ productsLoading: true, products: [] });
    }

    const graphqlQuery = {
        query: `
          query FetchAllOrders($page: Int, $perPage: Int, $searchData: String) {
            fetchOrders(page: $page, perPage: $perPage, searchData: $searchData) {
              orders {
                code,
                total_price,
                order_date,
                current_date,
                status,
                state,
                city,
                mobile_phone,
                first_name,
                last_name,
              }
              totalOrders
            }
          }
        `,
      variables: {
        page: productPage,
        perPage: this.state.perPage,
        searchData: searchData
      }
    };

    fetch(process.env.REACT_APP_BACKEND_URL + "/graphql", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + this.props.token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(graphqlQuery),
    })
      .then((res) => {
        return res.json();
      })
      .then((resData) => {
        console.log(resData);
        if (resData.errors) {
          throw new Error("مشکل در دریافت اطلاعات!");
        }

        this.setState({
            products: resData.data.fetchOrders.orders,
            totalProducts: resData.data.fetchOrders.totalOrders,
            productsLoading: false,
            productPage: productPage 
        });
           
      })
      .catch(this.catchError);
  };

  paymentGatewayStatus = () => {

    const graphqlQuery = {
        query: `
          query FetchGatewayStatus {
            fetchPaymentGatewayStatus {
              status,
              dirham_price,
            }
          }
         `,
      variables: {
        flag: true
      },
    };
    
    fetch(process.env.REACT_APP_BACKEND_URL + "/graphql", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + this.props.token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(graphqlQuery),
    })
      .then((res) => {
        return res.json();
      })
      .then((resData) => {
        console.log(resData);
        if (resData.errors) {
          throw new Error("مشکل در دریافت اطلاعات!");
        }

        this.setState({
            paymentGatewayIsActive: resData.data.fetchPaymentGatewayStatus.status
        });

        this.setState({
            dirham_price: resData.data.fetchPaymentGatewayStatus.dirham_price
        });
           
      })
      .catch(this.catchError);
  };
  

postPaymentGatewayStatusHandler = (status) => {
    
    const graphqlQuery = {
      query: `
        mutation swapPaymentGatewayStatus($status: Boolean) {
          changePaymentGatewayStatus(status: $status){
            status,
            dirham_price,
          }
        }
      `,
      variables: {
        status: status
      },
    };   
    
    
    fetch(process.env.REACT_APP_BACKEND_URL + "/graphql", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + this.props.token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(graphqlQuery),
    })
      .then((res) => {
        return res.json();
      })
      .then((resData) => {
        // console.log(resData);
        if (resData.errors) {
          throw new Error("خطایی در ذخیره اطلاعات به وجود آمده!");
        }

        this.setState({ paymentGatewayIsActive: resData.data.changePaymentGatewayStatus.status });
        
      })
      .catch((err) => {
        console.log(err);
      });


  };
  

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  loadDirhamPrice = () => {
 
    const graphqlQuery = {
        query: `
          mutation ApplyChangeDirhamPrice($dirham_price: Float!) {
            changeDirhamPrice(dirham_price: $dirham_price) {
              dirham_price
            }
          }
        `,
      variables: {
        dirham_price: parseFloat(this.state.dirham_price),
      }
    };

    fetch(process.env.REACT_APP_BACKEND_URL + "/graphql", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + this.props.token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(graphqlQuery),
    })
      .then((res) => {
        return res.json();
      })
      .then((resData) => {
        console.log(resData);
        if (resData.errors) {
          throw new Error("مشکل در دریافت اطلاعات!");
        }

        this.setState({
            dirham_price: resData.data.changeDirhamPrice.dirham_price,
        });
           
      })
      .catch(this.catchError);
  };
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  

  errorHandler = () => {
    this.setState({ error: null });
  };

  catchError = (error) => {
    this.setState({ error: error });
  };


  dirhamPriceInputChangeHandler = (input, value, files) => {
    this.setState((prevState) => {
      return {
        dirham_price: value,
      };
    });
  };

  postInputChangeHandler = (input, value, files) => {
    this.setState((prevState) => {
      return {
        searchValue: value,
        loading: false,
      };
    });
  };


  inputBlurHandler = (input) => {
    this.setState((prevState) => {
      return {
        searchTouched: true,          
      };
    });
  };

  cancelPostChangeHandler = () => {
    this.setState({
      searchValue: "",
      searchTouched: false
    });
    this.loadProducts(1);
  };

  acceptPostChangeHandler = () => {
    this.loadProducts(1, this.state.searchValue);     
  };



  acceptDirhamPriceChangeHandler = () => {
    this.loadDirhamPrice(this.state.dirham_price);     
  };








  handleChange = (event) => {
    
    if (event.target.id === "paymentGatewayIsActive") {
      this.setState({ paymentGatewayIsActive: event.target.checked });
    }
    this.postPaymentGatewayStatusHandler(event.target.checked)
  }


  render() {
    return (
      <Fragment>
        <ErrorHandler error={this.state.error} onHandle={this.errorHandler} />
        <MessageHandler
          showMessage={this.state.showMessage}
          onHandle={this.onCancelProductHandler}
          message={
            "آیا می‌خواهید " +
            this.state.label +
            ' کالایی "' +
            this.state.title +
            '" را حذف کنید؟'
          }
          onCancelModal={this.onCancelProductHandler}
          onAcceptModal={this.onDeleteProductTypeDicisionHandler}
          acceptMessage="تایید"
          cancelMessage="لغو"
        /> 
        <Content>
            <ContentHeader
              headerAction="مدیریت سفارشات"
              headerDescription="برای مشادهده و مدیریت سفارشات از این قسمت استفاده نمایید"
            />

            <Card> 
                <span className="mn-promo-report__header-card-bold-title">غیر فعال سازی درگاه</span>
                <div className="mn-card__body">
                    <form className="mn-ui-form" method="POST" id="searchForm" onSubmit={e => { e.preventDefault(); }}>
                        <div className="mn-ui-form__row mn-ui-form__row_padding">
                            <div className="mn-grid__row mn-grid__row--gap-lg mn-brand-card__footer">
                                <div className="c-ui-paginators">
                                    <div className="mn-grid__col mn-grid__col--gap-lg mn-grid__col--flex-initial mn-grid__col--sm-12 mn-grid__col--xs-gap" style={{minWidth: '400px'}}>
                                                
                                        
        

                                          <label htmlFor="paymentGatewayIsActive" className="uk-form-label">
                                            وضعیت درگاه:
                                          </label>
                                          <div className="mn-field-wrapper mn-field-wrapper--background">
                                            <label className="mn-ui-checkbox--container">
                                              <input
                                                type="checkbox"
                                                className="mn-ui-checkbox__checkbox"
                                                name="product[fake]"
                                                id="paymentGatewayIsActive"
                                                value="1"
                                                onChange={this.handleChange}
                                                checked={this.state.paymentGatewayIsActive}
                                              />
                                              <span className="mn-ui-checkbox__checkmark"></span>
                                              <span className="mn-ui-checkbox__label"> غیرفعال سازی درگاه </span>
                                            </label>
                                          </div>
                                     
                                    </div>
                                   
                                </div>
                            </div>
                        </div>
                    </form>             

                </div>
            </Card>

            <Card> 
              <span className="mn-promo-report__header-card-bold-title">درج قیمت درهم</span>
              <div className="mn-card__body">
                  <form className="mn-ui-form" method="POST" id="dirhamPriceForm" onSubmit={e => { e.preventDefault(); }}>
                      <div className="mn-ui-form__row mn-ui-form__row_padding">
                          <div className="mn-grid__row mn-grid__row--gap-lg mn-brand-card__footer">
                              <div className="c-ui-paginators">
                                  <div className="mn-grid__col mn-grid__col--gap-lg mn-grid__col--flex-initial mn-grid__col--sm-12 mn-grid__col--xs-gap" style={{minWidth: '400px'}}>
                                      <Input 
                                        id="dirhamPrice"
                                        label={"قیمت درهم:"}
                                        placeholder={"نرخ درهم را وارد کنید..."}
                                        type="number"
                                        control="input"
                                        required=""
                                        onChange={this.dirhamPriceInputChangeHandler}
                                        // onBlur={this.inputBlurHandler.bind(this, "dirhamPrice")}
                                        // valid={this.state.postForm["search"].valid}
                                        // touched={this.state.searchTouched}
                                        value={this.state.dirham_price}
                                        validationError={""}
                                      />
                                              
                                  </div>
                                  <div className="mn-grid__col--gap-lg mn-grid__col--xs-gap uk-flex uk-flex-bottom">
                                      <button className="mn-search-btn mn-search-btn--xs-block mn-search-btn--active--green  mn-search_padding" id="submitPriceButton" onClick={this.acceptDirhamPriceChangeHandler}>
                                          <span className="mn-seach__btn">محاسبه قیمت کالاها</span>
                                      </button>
                                  </div>
                              </div>
                              
                          </div>
                      </div>
                  </form>
              </div>
            </Card>












            <Card> 
                <span className="mn-promo-report__header-card-bold-title">جستجو و فیلتر</span>
                <div className="mn-card__body">
                    <form className="mn-ui-form" method="POST" id="searchForm" onSubmit={e => { e.preventDefault(); }}>
                        <div className="mn-ui-form__row mn-ui-form__row_padding">
                            <div className="mn-grid__row mn-grid__row--gap-lg mn-brand-card__footer">
                                <div className="c-ui-paginators">
                                    <div className="mn-grid__col mn-grid__col--gap-lg mn-grid__col--flex-initial mn-grid__col--sm-12 mn-grid__col--xs-gap" style={{minWidth: '400px'}}>
                                       <Input 
                                          id="search"
                                          label={"جستجو:"}
                                          placeholder={"عبارت مورد نظرتان را وارد کنید..."}
                                          type="text"
                                          control="input"
                                          required=""
                                          onChange={this.postInputChangeHandler}
                                          onBlur={this.inputBlurHandler.bind(this, "search")}
                                          // valid={this.state.postForm["search"].valid}
                                          touched={this.state.searchTouched}
                                          value={this.state.searchValue || ""}
                                          validationError={""}
                                        />
                                                
                                        {/* <label className="uk-form-label uk-flex uk-flex-between">جستجو:</label>
                                        <div className="field-wrapper ui-select ui-select__container">
                                          <div className="mn-ui-input">
                                            <input type="text" name="brand-search" className="mn-ui-input__field mn-ui-input__field--order" id="brand-search" placeholder="عبارت مورد نظرتان را وارد کنید..."/>
                                          </div>                                        
                                        </div> */}
                                    </div>
                                    <div className="mn-grid__col--gap-lg mn-grid__col--xs-gap uk-flex uk-flex-bottom">
                                        <button className="mn-search-btn mn-search-btn--xs-block mn-search-btn--active mn-search-btn--search-form mn-search_padding" id="submitButton" disabled={this.state.searchValue.length<3} onClick={this.acceptPostChangeHandler}>
                                            <span className="mn-seach__btn">جستجو</span>
                                        </button>
                                        <button type="button" className="mn-content-categories__search-reset" id="resetButton" disabled={this.state.searchValue.length<3} onClick={this.cancelPostChangeHandler}></button>
                                    </div>
                                </div>
                                {/* <div className="mn-grid__col--gap-lg mn-grid__col--xs-gap uk-flex uk-flex-bottom">
                                    <Link to='/add-product' className="mn-product_link">
                                            <div className="mn-search-btn mn-search-btn--xs-block mn-search-btn--active--green mn-mega-campaigns__btns-green-plus mn-search_padding">
                                                ایجاد کالای جدید
                                            </div>
                                    </Link>
                                </div> */}
                            </div>
                        </div>
                    </form>             

                </div>
            </Card>
            <Card>
                <div className="c-card__wrapper">
                    <div className="mn-card__header mn-card__header--table">
                        {/* <Link to='/add-product' className="mn-product_link">
                                <div className="mn-search-btn mn-search-btn--xs-block mn-search-btn--active--green mn-mega-campaigns__btns-green-plus mn-search_padding">
                                    ایجاد کالای جدید
                                </div>
                        </Link> */}

                        <Paginator
                          onNext={this.loadProducts.bind(this)}
                          lastPage={Math.ceil(this.state.totalProducts / this.state.perPage)}
                          totalProducts={this.state.totalProducts}
                          currentPage={this.state.productPage}
                        />
                        {/* <div className="mn-grid__col--gap-lg mn-grid__col--xs-gap uk-flex uk-flex-bottom"> 
                            <Link to='/add-product' className="mn-search-btn mn-search-btn--xs-block mn-search-btn--active--green mn-mega-campaigns__btns-green-plus mn-search_padding">
                                <span className="mn-seach__btn">ایجاد برند جدید</span>
                            </Link>
                         </div> */}
                         
                    </div>
                    <div className={[ "c-card__body c-ui-table__wrapper", this.state.productsLoading ? "c-content-loading" : "" ].join(" ")}>
                        <table className="c-ui-table js-search-table " data-sort-column="" data-sort-order="asc" data-search-url="/commissions/search/" data-auto-reload-seconds="0" data-new-ui="1" data-is-header-floating="1" data-has-checkboxes="">
                            <thead>
                                <tr className="c-ui-table__row">
                                    <th className="c-ui-table__header c-ui-table__header--nowrap ">
                                        <span className="js-search-table-column">ردیف</span>
                                    </th>
                                    
                                    <th className="c-ui-table__header c-ui-table__header--nowrap ">
                                        <span className="table-header-searchable">شماره سفارش</span>
                                    </th>
                                
                                    <th className="c-ui-table__header c-ui-table__header--nowrap ">
                                        <span className="table-header-searchable">نام کاربر</span>
                                    </th>
                                    
                                    <th className="c-ui-table__header c-ui-table__header--nowrap ">
                                        <span className="table-header-searchable">تاریخ سفارش</span>
                                    </th>
                                    
                                    <th className="c-ui-table__header c-ui-table__header--nowrap ">
                                        <span className="table-header-searchable"> جمع کل </span>
                                    </th>
                                    <th className="c-ui-table__header c-ui-table__header--nowrap ">
                                        <span className="table-header-searchable">استان</span>
                                    </th>
                                    <th className="c-ui-table__header c-ui-table__header--nowrap ">
                                        <span className="table-header-searchable">شهر</span>
                                    </th>
                                    <th className="c-ui-table__header c-ui-table__header--nowrap ">
                                        <span className="table-header-searchable">وضعيت</span>
                                    </th>
                                    <th className="c-ui-table__header c-ui-table__header--nowrap ">
                                        <span className="table-header-searchable">مشاهده</span>
                                    </th>
                                </tr>
                            </thead>


                            <tbody>
                              {this.state.products !== [] && (
                              <Fragment>
                                {this.state.products.map((data, index) => (
                                <tr key={index}>
                                  <td className="c-ui-table__cell c-ui-table__cell--smaller"> {index + 1} </td>

                                  <td className="c-ui-table__cell"> {data.code} </td>

                                  <td className="c-ui-table__cell c-ui-table__cell-desc c-ui--pt-15 c-ui--pb-15"> {data.first_name + ' ' + data.last_name} </td>

                                  <td className="c-ui-table__cell">{dateTimeOnlyReadable(data.order_date)}</td>
                                  
                                  <td className="c-ui-table__cell ">{data.total_price}</td>
                                  
                                  <td className="c-ui-table__cell">{data.state}</td>

                                  <td className="c-ui-table__cell">{data.city}</td>

                                  <td className="c-ui-table__cell">
                                    <span className="mn-row__status-ui edit">
                                        {data.status==3?"فعال":""}
                                    </span>
                                  </td>

                                  <td className="c-ui-table__cell">
                                    <Link className="uk-padding-remove mn-product_link" to={"/order/detail/"+data.code}>
                                        <div className="c-mega-campaigns-join-list__container-table-btn c-mega-campaigns-join-list__container-table-btn--view c-ui--mr-10 js-tool-tip-desc" aria-expanded="false"></div>
                                        <div className="c-rating-chart__description-tooltip c-mega-campaigns-join-list__container-table-btn-tooltip uk-text-nowrap uk-dropdown" uk-dropdown="boundary: .js-tool-tip-desc; pos: bottom-center;delay-hide: 0;offset: 10;" style={{left: '39.8px', top: '82.5333px'}}>مشاهده سفارش</div>
                                    </Link>
                                  </td>
                                </tr>
                                ))}
                              </Fragment>
                              )}
                            </tbody>
                        </table>
                    </div>
                    <div className="c-card__footer">
                        {/* <Link to='/add-product' className="mn-product_link">
                                <div className="mn-search-btn mn-search-btn--xs-block mn-search-btn--active--green mn-mega-campaigns__btns-green-plus mn-search_padding">
                                    ایجاد کالای جدید
                                </div>
                        </Link> */}

                        <Paginator
                          onNext={this.loadProducts.bind(this)}
                          lastPage={Math.ceil(this.state.totalProducts / this.state.perPage)}
                          totalProducts={this.state.totalProducts}
                          currentPage={this.state.productPage}
                        />
                    </div>
                    {this.state.productsLoading && (
                      <div className="c-content-loader">
                        <Newloader/>
                      </div>
                    )} 
                    
                </div>
            </Card>
        </Content>
      </Fragment>
    );
  }
}

export default OrderList;

